import { inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class RoleGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const roles = route.data['roles'] as string[] | undefined;
    if (!roles) return true;

    const user = this.authService.currentUserValue;
    if (!user) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    const currentRoles = [
      ...(user.role ? [user.role] : []),
      ...(Array.isArray((user as any).roles) ? (user as any).roles : [])
    ] as string[];

    if (currentRoles.some((role) => roles.includes(role))) {
      return true;
    }

    this.router.navigate(['/auth/login']);
    return false;
  }
}
